/**
 * SgmELearning
 *
 * @author Leon Wei
 * @date 2016-11-16
 * @copyright
 */

/**
 * 图片
 */
//系统主要logo
export const sys_main_logo = require('assets/images/loginLogo2.png');

export const sys_home_img = require('assets/images/home/home.jpg')

//加载失败
export const sys_img_loadingFailed = require('assets/images/loadingFailed.jpg');
export const sys_img_loadingFailedSmall = require('assets/images/loadingFailedSmall.jpg');
export const sys_img_non_existent = require('assets/images/non_existent.jpg');
export const sys_img_non_existent_png = require('assets/images/non_existent.png');


//考试
export const sys_exam_precent_min = require('assets/images/exam/min.png');
export const sys_exam_precent_max = require('assets/images/exam/max.png');
export const sys_exam_precent_avg = require('assets/images/exam/avg.png');

//课程
export const sys_program_code_rule = require('assets/images/program/codeRule1.png');
export const sys_program_default_image = require('assets/images/program/studyProgramImage.jpg');

//直播
export const sys_live_default_image = require('assets/images/live/liveImage.jpg');

//路径
export const sys_path_default_image = require('assets/images/path/pathImg.jpg');
export const sys_pathStage_default_image = require('assets/images/path/pathStage.jpg');
export const sys_pathMap_default_image = require('assets/images/path/pathMap.png');

//班级课堂助手图标
export const sys_classAide_exam_png = require('assets/images/classAide/exam.png')
export const sys_classAide_homework_png = require('assets/images/classAide/homework.png')
export const sys_classAide_onlineProgram_png = require('assets/images/classAide/onlineProgram.png')
export const sys_classAide_questionnaire_png = require('assets/images/classAide/questionnaire.png')
export const sys_classAide_remoteAuth_png = require('assets/images/classAide/remoteAuth.png')
export const sys_classAide_remoteEvaluation_png = require('assets/images/classAide/remoteEvaluation.png')
export const sys_classAide_satisfaction_png = require('assets/images/classAide/satisfaction.png')
export const sys_classAide_sign_png = require('assets/images/classAide/sign.png')
export const sys_classAide_smallClass_png = require('assets/images/classAide/smallClass.png')

//融入辅导
export const sys_counseling_proess_active = require('assets/images/counseling/processActive.png')
export const sys_counseling_process_active_white = require('assets/images/counseling/processActiveWhite.png')
export const sys_counseling_in_progress = require('assets/images/counseling/inProgress.png')
export const sys_counseling_in_progress_white = require('assets/images/counseling/inProgressWhite.png')
export const sys_counseling_tips = require('assets/images/counseling/tips.png')
export const sys_counseling_content_in_progress = require('assets/images/counseling/contentInProgress.png')
export const sys_counseling_content_completed = require('assets/images/counseling/contentCompleted.png')

/**
 * excel
 */
export const excel_demo = require('assets/excel/demo.xlsx');
export const excel_classResultTemp = require('assets/excel/classResultTemp.xlsx');
export const excel_classStudentTemp = require('assets/excel/classStudentTemp.xlsx');
export const excel_organizationTemp = require('assets/excel/organizationTemp.xlsx');
export const excel_roleUserTemp = require('assets/excel/roleUserTemp.xlsx');
export const excel_examQuestion = require('assets/excel/examQuestion.xlsx');
export const excel_categoryTemp = require('assets/excel/category.xlsx');
export const excel_questionTemp = require('assets/excel/question.xlsx');
export const excel_personImportTemporary = require('assets/excel/personImportTemporary.xlsx');
export const excel_vinImportTemp = require('assets/excel/vinImportTemp.xlsx');
export const excel_personImportGetPersonInfo = require('assets/excel/personImportGetPersonInfo.xlsx');
export const excel_importSchoolCooperationPerson = require('assets/excel/importSchoolCooperationPerson.xlsx');
export const excel_remoteAuthTemp = require('assets/excel/remoteAuthTemp.xlsx');
export const excel_remoteAuthTempNew = require('assets/excel/remoteAuthTempNew.xlsx');
export const excel_remoteAuthNevTemp = require('assets/excel/remoteAuthNEVTemp.xlsx');
export const excel_applyStudent = require('assets/excel/applyStudent.xlsx');
export const excel_programAssessmentRulesTemp = require('assets/excel/programAssessmentRulesTemplate.xlsx');
export const excel_vctAssessmentRulesTemp = require('assets/excel/vctAssessmentRulesTemplate.xlsx');
export const excel_dealerAssessmentRulesTemp = require('assets/excel/dealerAssessmentRulesTemplate.xlsx');
export const excel_remoteAuthScoreFileImport = require('assets/excel/remoteAuthScoreFileImport.xlsx');
export const excel_normalDealerTemp = require('assets/excel/normalDealerTemp.xlsx');
export const excel_subjectCreditRecordPersonTemp = require('assets/excel/subjectCreditRecordPersonTemp.xlsx');
export const excel_subjectCreditRecordDealerTemp = require('assets/excel/subjectCreditRecordDealerTemp.xlsx');
export const excel_classResultApply = require('assets/excel/classResultApply.xlsx');
export const excel_importOrg = require('assets/excel/importOrg.xlsx');
export const excel_orgRemoteEvaluationScoreFileImport = require('assets/excel/orgRemoteEvaluationScoreFileImport.xlsx');
export const excel_thirdCorpUserTemp = require('assets/excel/thirdCorpUserTemp.xlsx');
export const excel_seriesImportTemp = require('assets/excel/seriesImportTemp.xlsx');
export const excel_trainPathFileImportTemp = require('assets/excel/trainPathFileImportTemp.xlsx');
export const excel_importPerson = require('assets/excel/importPerson.xlsx');
export const excel_preAuditStandardTemplate = require('assets/excel/preAuditStandardTemplate.xlsx');
export const excel_interviewQuestionTemplate = require('assets/excel/interviewQuestionTemplate.xlsx');
export const excel_positionAuthStateImportTemp = require('assets/excel/positionAuthStateImportTemp.xlsx');
export const excel_batchPositionAuthStateImportTemp = require('assets/excel/batchPositionAuthStateImportTemp.xlsx');
export const excel_batchImportDPState = require('assets/excel/batchImportDPState.xlsx');
export const excel_liveSurveyTemp = require('assets/excel/liveSurveyTemp.xlsx');

export const excel_learningScore1 = require('assets/excel/import_learningScore1.xlsx');
export const excel_learningScore2 = require('assets/excel/import_learningScore2.xlsx');

/**
 * empty
 */
export const empty_png = require('assets/images/empty/empty.png')

//应用中心-我的作业图片
export const sys_icon_personal_homework_audio = require('assets/images/homework/audio.jpg')
export const sys_icon_personal_homework_video = require('assets/images/homework/video.jpg')

//面试导出
export const sys_icon_resume_logo = require('assets/images/resume/logo.png')
export const sys_icon_resume_buick = require('assets/images/resume/buick.jpg')

//上传图片新样式图标
export const upload_pic_icon = require('assets/images/upload-pic-icon.png');
//产品知识库
export const sys_proKnowledge_default_image = require('assets/images/proKnowledge/proKnowledge.png');

//智能电话
export const sys_phone_icon = require('assets/images/yunTel/phone-icon.png');
export const sys_phone_log_icon = require('assets/images/yunTel/phone-log-icon.png');
export const sys_sound_play_icon = require('assets/images/yunTel/sound-play-icon.png');
